import { BRAND } from '@/config/brand';
import { useTheme } from '@/hooks/useTheme';

/** Site logo that follows the V2 theme (white wordmark on dark, navy wordmark on light). */
const BrandLogo = ({ className }: { className?: string }) => {
  const { theme } = useTheme();
  return (
    <img
      src={theme === 'light' ? BRAND.logoOnLight : BRAND.logo}
      alt={BRAND.name}
      className={className}
    />
  );
};

export default BrandLogo;
